import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Shortcuts from '../components/Shortcuts';
import ModalContainer from './ModalContainer';
import Modal from '../modal-shim';
import Mousetrap from 'mousetrap';
import {connect} from 'react-redux';
import {onModal} from '../actions/ModalActions';

const SHORTCUTS_MODAL = 'shortcutsModal';

@connect(null, {onModal})
export default class ShortcutsContainer extends Component {
    static propTypes = {
        onModal: PropTypes.func,
    };

    componentWillMount() {
        Mousetrap.bind(['?'], (e) => {
            e.preventDefault();
            this.showShortcuts();
        });
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['?']);
    }

    showShortcuts = () => {
        this.props.onModal(SHORTCUTS_MODAL, true);
    };

    render() {
        return (
            <ModalContainer name={SHORTCUTS_MODAL}>{(isOpen, openModal, closeModal) => (
                <Modal show={isOpen} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{'Keyboard shortcuts'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Shortcuts/>
                    </Modal.Body>
                </Modal>
            )}</ModalContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ShortcutsContainer.js